module.exports = __webpack_public_path__ + "img/locationPin.d15ea77f.svg";